export default __webpack_public_path__ + "static/media/upload-icon.9fb27493.svg";